<template>
  <div class="content-box">
    <div class="element-wrapper pb-0">
      <div class="element-header">
        <div class="row">
          <div class="col-md 8 mr-auto">
            <h3 class>Global - Detalhes Faturas - {{filtro.tipo === 'negociacao' ? 'Taxa de Negociação' : 'Taxa Emissão do Cartão'}}</h3>
          </div>
          <div class="col-auto">
            <b-btn @click="exportar">
              <i class="fas fa-file-excel"></i>  Exportar
            </b-btn>
            <b-button @click="voltar">Voltar</b-button>
          </div>
        </div>
      </div>
    </div>

    <filtro-fatura :find="find"></filtro-fatura>

    <div class="col mt-3">
      <div class="element-wrapper pb-0">
        <b-card>
          <div class="container">
            <div class="row">
              <div class="col">
                <label for>Total Faturas</label>
                <h5>{{resumoFatura.qtdTotalFaturas}}</h5>
              </div>
              <div class="col">
                <label for>Faturas Pagas</label>
                <h5>{{resumoFatura.qtdFaturasPagas}}</h5>
              </div>
              <div class="col">
                <label for>Faturas Aguardando Pagamento</label>
                <h5>{{resumoFatura.qtdFaturasAguardando}}</h5>
              </div>
              <div class="col">
                <label for>Faturas Vencidas</label>
                <h5>{{resumoFatura.qtdFaturasVencidas}}</h5>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <div class="col mt-3">
      <b-card>
        <b-card-body class="p-1">
          <div class="row">
            <b-col class="my-1">
              <b-pagination
                  v-if="pagination.totalRows > 10"
                  v-model="pagination.page"
                  :total-rows="pagination.totalRows"
                  :per-page="pagination.limit"
                  align="fill"
                  size="sm"
                  class="my-0"
              ></b-pagination>
            </b-col>
          </div>
          <div class="row">
            <div class="col">
              <b-table show-empty emptyText="Não há itens para exibir"
                       ref="table" id="my-table"
                       selected-variant="success"
                       :current-page="pagination.page"
                       :per-page="pagination.limit"
                       :busy="loading" :items="detalhesFaturas" responsive
                       :fields="fieldsTable" small
                       striped hover>
                <template slot="[nome]" slot-scope="row">
                  {{row.item.pedido.client.name}}<br>
                  <small>{{'CPF: ' + row.item.pedido.client.cpf}}</small>
                </template>
                <template slot="[idPedido]" slot-scope="row">
                  <router-link :to="{name: 'PedidoDetail', query:{id: row.item.pedido._id}}">{{row.item.pedido.idPedidoVindi}}</router-link>
                </template>
                <template slot="[formaPagamento]" slot-scope="row">
                  {{getCharge(row.item.vindi.charges).payment_method.public_name}}
                </template>
                <template slot="[dataVencimento]" slot-scope="row">
                  {{formataData(getCharge(row.item.vindi.charges).due_at)}}
                </template>
                <template slot="[dataPagamento]" slot-scope="row">
                  {{formataData(getCharge(row.item.vindi.charges).paid_at)}}
                </template>
                <template slot="[vlTotal]" slot-scope="row">
                  {{ Number(getCharge(row.item.vindi.charges).amount) | money }}
                </template>
                <template slot="[vlTotalDrAchei]" slot-scope="row" v-if="filtro.tipo === 'negociacao'">
                  {{ Number((row.item.vlTotalDrAchei)) | money }}
                </template>
                <template slot="[vlTotalImposto]" slot-scope="row" v-if="filtro.tipo === 'negociacao'">
                  {{ Number(row.item.vlTotalImposto) | money }}
                </template>
                <template slot="[vlTotalDrAcheiImposto]" slot-scope="row" v-if="filtro.tipo === 'negociacao'">
                  {{ Number(row.item.vlTotalDrAchei) + Number(row.item.vlTotalImposto) | money }}
                </template>
                <template slot="[vlTotalEmpresa]" slot-scope="row" v-if="filtro.tipo === 'negociacao'">
                  {{ Number(row.item.vlTotalEmpresa) | money }}
                </template>
                <template slot="[statusPagamento]" slot-scope="row">
                  {{traduzirStatusPagamento(row.item.vindi)}}
                </template>
                <template slot="[actions]" slot-scope="row">
                  <b-btn variant="light" @click="view(row.item)">
                    <i class="fas fa-search"></i>
                  </b-btn>
                </template>
              </b-table>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <viewTransacoesAvulsaModal v-if="transacao" :pedido="pedido" :transacao="transacao"></viewTransacoesAvulsaModal>
  </div>
</template>

<script>
import filtroFatura from '@/components/financeiro/FiltroFatura';
import viewTransacoesAvulsaModal from '@/components/transacoesAvulsa/ViewTransacoesAvulsaModal';

import moment from "moment";
export default {
  name: "detalhesFaturaAvulsa",
  components: {
    filtroFatura,
    viewTransacoesAvulsaModal
  },
  async mounted() {
    this.resumoFatura = await this.$store.dispatch('totalizadorFaturaAvulsa')
        .then(response => response.data);
  },
  computed: {
    filtro() {
      return this.$store.getters.filtroFatura;
    },
    loading() {
      return this.$store.getters.loading;
    },
    fieldsTable() {
      if (this.filtro.tipo === 'negociacao') {
        return [{key: 'idPedido', label: 'Pedido'},
            {key: 'nome', label: 'Cliente'},
            {key: 'formaPagamento', label: 'Forma de pagamento'},
            {key: 'dataVencimento', label: 'Data de Vencimento'},
            {key: 'dataPagamento', label: 'Data do Pagamento'},
            {key: 'vlTotal', label: 'Valor Total'},
            {key: 'vlTotalDrAchei', label: 'Valor DrAchei'},
            {key: 'vlTotalImposto', label: 'Valor Imposto'},
            {key: 'vlTotalDrAcheiImposto', label: 'Valor DrAchei + Imposto'},
            {key: 'vlTotalEmpresa', label: 'Valor Empresa'},
            {key: 'statusPagamento', label: 'Status pagamento'},
            {key: 'actions', label: ''}];
      }
      return [{key: 'idPedido', label: 'Pedido'},
          {key: 'nome', label: 'Cliente'},
          {key: 'formaPagamento', label: 'Forma de pagamento'},
          {key: 'dataVencimento', label: 'Data de Vencimento'},
          {key: 'dataPagamento', label: 'Data do Pagamento'},
          {key: 'vlTotal', label: 'Valor Total'},
          {key: 'statusPagamento', label: 'Status pagamento'},
          {key: 'actions', label: ''}]
    }
  },
  data:() => ({
    pedido: null,
    transacao: null,
    resumoFatura: {},
    pagination: {
      limit: 10,
      page: 1,
      totalRows: 0,
    },
  }),
  methods: {
    async find() {
      this.resumoFatura = await this.$store.dispatch('totalizadorFaturaAvulsa')
          .then(response => response.data);
      this.pagination.page = 1;
      this.$store.dispatch("setLoadingTable", true);
      this.$root.$emit('bv::refresh::table', 'my-table')
      this.$store.dispatch("setLoadingTable", false);
    },
    detalhesFaturas(ctx) {
      try {
        this.$store.dispatch("setLoading", true);

        this.pagination.page = ctx.currentPage;
        this.pagination.limit = ctx.perPage;

        this.$store.dispatch('setPagination', this.pagination);

        return this.$store.dispatch('findFaturasAvulsaCartao')
            .then(response => {
              const result = response.data;
              this.pagination.totalRows = result.totalCount;
              return result.data || [];
            });
      } catch (e) {
        // eslint-disable-next-line
        console.log(e);
        alert(e.message);
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    },
    getCharge(charges) {
      if (!charges) {
        return {}
      }
      if (charges.length === 1) {
        return charges[0];
      }

      return charges.find(charge => charge.status === 'pending' || charge.status === 'paid')
    },
    formataData(value) {
      if (!value) return '';
      return moment(value).format("DD/MM/YYYY");
    },
    isVencida(fatura) {
      let dataVencimento = new Date(this.getCharge(fatura.charges).due_at);
      return moment().isSameOrAfter(dataVencimento);
    },
    traduzirStatusPagamento(fatura) {
      let statusVindi = this.getCharge(fatura.charges).last_transaction.status || fatura.status;
      switch (statusVindi) {
        case 'processing':
          return 'Processando pagamento';
        case 'failure':
          return 'Falha ao processar pagamento';
        case 'rejected':
          return 'Pagamento rejeitado';
        case 'success':
        case 'paid':
          return 'Pagamento Efetuado';
        case 'pending':
        case 'waiting':
          if (this.isVencida(fatura)) {
            return 'Vencida'
          }
          return 'Aguardando pagamento';
        case 'canceled':
          return 'Cancelado';
        default:
          return statusVindi;
      }
    },
    voltar() {
      window.history.back();
    },
    view(faturaAvulsa) {
      this.transacao = faturaAvulsa;
      this.pedido = faturaAvulsa.pedido;
      this.$nextTick(() => this.$bvModal.show('modalViewTransacaoAvulsa'));
    },
    exportar() {
      this.$store.dispatch('setLoading', true);
      this.$store.dispatch('findFaturasAvulsaCartaoExcel');
      this.$store.dispatch('setLoading', false);
    }
  }
}
</script>

<style scoped>

</style>
